import { Component, VERSION } from '@angular/core';
import { UserModel } from './models/user/user.model';
import {Globals} from './shared/globals/globals';
import { GlobalsService } from './shared/globals/globals.service';
import { HeaderTemplateComponent } from './components/templates/header-template/header-template.component';
import { ToastModule } from 'primeng/toast';
import { RouterOutlet } from '@angular/router';
import { FooterTemplateComponent } from './components/templates/footer-template/footer-template.component';
import { NgIf } from '@angular/common';
import { LoaderComponent } from './shared/loader/loader.component';

@Component({
    selector: 'wings-mobile',
    templateUrl: './wings-mobile.component.html',
    styleUrls: ['./wings-mobile.component.scss'],
    imports: [HeaderTemplateComponent, ToastModule, RouterOutlet, FooterTemplateComponent, NgIf, LoaderComponent]
})
export class WingsMobileComponent {

	version = VERSION.full;

	constructor(public globals : Globals) {
		GlobalsService.get('changeUser').subscribe({
			next: (res: UserModel) => {
				this.globals.user.country = res.country;
				this.globals.user.warehouse = res.warehouse;
				this.globals.user.userName = res.userName;

				localStorage.setItem('user', JSON.stringify(this.globals.user))
			}
		});

		GlobalsService.get('changeLanguage').subscribe({
			next: (res: string) => {
				localStorage.setItem('user', JSON.stringify(this.globals.user))
				this.globals.user.language = res;
			}
		})
	}
}

